module.exports = __webpack_public_path__ + "img/customer-service.30c6b9fe.svg";